import React from "react";
import PropTypes from "prop-types";
import { Configure } from "react-instantsearch-dom";

import { useAlgolia } from "hooks";

const AlgoliaConfigure = (props) => {
  const { getUserToken } = useAlgolia();
  const { sendTokenOnlyForPaidUser, ...newProps } = props;

  return <Configure {...newProps} userToken={getUserToken(sendTokenOnlyForPaidUser)} />;
};

AlgoliaConfigure.propTypes = {
  sendTokenOnlyForPaidUser: PropTypes.bool,
};

AlgoliaConfigure.defaultProps = {
  sendTokenOnlyForPaidUser: false,
};

export default AlgoliaConfigure;
